import B2BLayout from "@/module_b2b_users/views/layout/B2bLayout.vue";
import store from "@/store";
import defaultUser from "@/module_user/defaultUser.json";
import SocialLayout from "@/module_social/views/SocialLayout";

const APP_NAME = 'EliteFit - ';

const routes = [
  {
    path: "",
    component: B2BLayout,
    beforeEnter: checkUserLogin,
    redirect: getRedirectTo(),
    props: route => ({ search: route.query.search}),
    children: [
      {
        path: 'user',
        redirect: store.state.defaultLandingPage,
      },
      {
        path: 'user/old/main',
        component: () => import('./views/main.vue'),
        name: 'MainOld',
        beforeEnter: checkUserLogin,
      },
      {
        path: 'user/tnx',
        component: () => import('@/module_b2b_users/views/TransactionStatus.vue'),
        name: 'UserTransactionStatus',
        beforeEnter: checkUserLogin
      },
      {
        path: 'user/billing',
        component: () => import('@/module_b2b_users/views/Transactions.vue'),
        name: 'UserBilling',
        beforeEnter: checkUserLogin
      },
      {
        path: 'user/discover',
        component: () => import('@/module_user/views/DiscoverV2.vue'),
        name: 'Discover',
        beforeEnter: checkUserLogin,
      },
      {
        path: 'user/assessment',
        component: () => import("@/module_assessment/views/Assessments.vue"),
        name: 'UserAssessments'
    },
    {
        path: 'user/assessment/add',
        component: () => import("@/module_assessment/views/CreateAssessment.vue"),
        name: 'UserCreateAssessment'
    },
    {
        path: 'user/end-assessment',
        component: () => import("@/module_assessment/views/EndAssessment.vue"),
        name: 'UserEndAssessment'
    },
    {
        path: 'user/assessment/anatomy',
        component: () => import("@/module_assessment/components/Anatomy.vue"),
        name: 'UserAnatomy'
    },
    {
        path: 'user/assessment/recommendations',
        component: () => import("@/module_assessment/components/VideoList.vue"),
        name: 'UserRecommendations'
    },
    {
        path: 'user/assessment/viewReport/:id',
        component: () => import("@/module_assessment/components/Report.vue"),
        name: 'UserViewReport',
        props: true 
    },
    {
        path: 'user/assessment/view/:id',
        component: () => import("@/module_assessment/views/ViewAssessment.vue"),
        name: 'UserViewAssessment',
        props: true 
    },
      {
        path: 'user/main',
        component: () => {
          const theme = store.state.userInfo?.corporate?.theme;
  
          if (theme === 'physiotherapy') {
            return import('./views/TreatmentPlan');
          } else if (theme === 'assessment') {
            return import('../module_assessment/views/Assessments.vue');
          } else {
            return import('./views/MainV2.vue');
          }
        },
        name: 'Main',
        beforeEnter: checkUserLogin,
      },      
      {
        path: 'user/challenges',
        component: () => import('./views/Challenges.vue'),
        name: 'b2b-challenges',
        beforeEnter: checkUserLogin,
      },
      {
        path: 'user/programs',
        component: () => import('./views/ProgramsV3.vue'),
        name: 'b2b-programs',
        beforeEnter: checkUserLogin,
      },
      {
        path: 'user/programs-v2',
        component: () => import('./views/ProgramsV3.vue'),
        name: 'b2b-programs-v2',
        beforeEnter: checkUserLogin,
      },
      {
        path: 'user/programs/completed',
        component: () => import('./views/ProgramCompleted.vue'),
        name: 'b2b-programs-completed',
        beforeEnter: checkUserLogin,
      },
      {
        path: 'user/program/videos/v2',
        component: () => import('./views/ProgramVideosV2.vue'),
        name: 'b2b-program-videos-v2',
        beforeEnter: checkUserLogin,
      },
      {
        path: 'user/program/videos',
        component: () => import('./views/ProgramVideos.vue'),
        name: 'b2b-program-videos',
        beforeEnter: checkUserLogin,
      },
      {
        path: 'user/completed-challenges',
        component: () => import('./views/CompletedChallenges.vue'),
        name: 'b2b-completed-challenges',
        beforeEnter: checkUserLogin,
      },
      {
        path: 'user/expired-challenges',
        component: () => import('./views/ExpiredChallenges.vue'),
        name: 'b2b-expired-challenges',
        beforeEnter: checkUserLogin,
      },
      {
        path: 'user/challenge/:index',
        component: () => import('./views/Challenges.vue'),
        name: 'ShowB2BChallenge',
        beforeEnter: checkUserLogin,
      },
      {
        path: 'user/program/:index',
        component: () => import('./views/Programs.vue'),
        name: 'ShowB2BProgram',
        beforeEnter: checkUserLogin,
      },
      // {
      //   path: "/leaderboard",
      //   component: () => import("@/module_admin/views/LeaderBoard.vue"),
      //   name: "leaderboard",
      //   meta: {
      //     title: APP_NAME + "Leaderboard",
      //   },
      //   beforeEnter: checkUserLogin,
      // },
      {
        path: "/leaderboard",
        component: () =>
          import("@/module_admin/views/LeaderboardV2/LeaderboardV2.vue"),
        name: "leaderboard_v2",
        meta: {
          title: APP_NAME + "Leaderboard",
        },
        beforeEnter: checkUserLogin,
      },
      {
        path: "/leaderboard/team",
        component: () =>
          import("@/module_admin/views/LeaderboardV2/MyTeams.vue"),
        name: "leaderboard_team",
        meta: {
          title: APP_NAME + "Leaderboard",
        },
        beforeEnter: checkUserLogin,
      },
      {
        path: "/corporate-dashboard",
        component: () => import("@/module_user/views/CorporateDashboard.vue"),
        name: "CorporateDashboard",
        meta: {
          title: APP_NAME + "Corporate Dashboard",
        },
        beforeEnter: checkUserLogin,
      },
      {
        path: "/progress",
        component: () => {
          return !isPhysio() ?
          import("@/module_user/views/UserProgress.vue"):
          import("@/module_user/views/PhysioPatientProgress.vue");
        },
        name: "User Progress",
        meta: {
          title: APP_NAME + "User Progress",
        },
        beforeEnter: checkUserLogin,
      },
      {
        path: "/achievements",
        component: () => import("@/module_user/views/Achievements.vue"),
        name: "User Achievements",
        meta: {
          title: APP_NAME + "User Achievements",
        },
        beforeEnter: checkUserLogin,
      },
      {
        path: "/achievements-points",
        component: () =>
          import("@/module_user/views/AchievementPointHistory.vue"),
        name: "Achievements Points",
        meta: {
          title: APP_NAME + "Achievements Points",
        },
        beforeEnter: checkUserLogin,
      },
      {
        path: "/redeem",
        component: () => import("@/module_user/views/Coupon.vue"),
        name: "Redeem",
        meta: {
          title: APP_NAME + "Redeem",
        },
        beforeEnter: checkUserLogin,
      },
      {
        path: "/redeem-history",
        component: () => import("@/module_user/views/CouponRedeemHistory.vue"),
        name: "Redeem History",
        meta: {
          title: APP_NAME + "Redeem History",
        },
        beforeEnter: checkUserLogin,
      },
      {
        path: "/help",
        component: () => import("@/module_user/views/SupportContent.vue"),
        name: "User Support Content",
        meta: {
          title: APP_NAME + "User Support Content",
        },
        beforeEnter: checkUserLogin,
      },
      {
        path: "/edit-profile",
        component: () => import("@/module_user/views/EditUserProfile.vue"),
        name: "Edit User Profile",
        meta: {
          title: APP_NAME + "Edit User Profile",
        },
        beforeEnter: checkUserLogin,
      },
      {
        path: 'user/end-workout',
        component: () => import('@/module_user/views/EndWorkout.vue'),
        name: "EndWorkout",
        meta: {
          title: APP_NAME + "End Workout",
        },
        beforeEnter: checkUserLogin,
      },
      {
        path: 'user/end-workout/rep',
        component: () => import('@/module_user/views/RepEndWorkout.vue'),
        name: "RepEndWorkout",
        meta: {
          title: APP_NAME + "End Workout",
        },
        beforeEnter: checkUserLogin,
      },
      {
        path: '/verify',
        component: () => import('@/module_b2b_users/views/VerifyUser'),
        name: 'VerifyUser',
        beforeEnter: checkUserLogin,
      },
      //  social
      {
        path: "/social",
        component: SocialLayout,
        beforeEnter: checkUserLogin,
        name: "EliteFitSocial",
        children: [
          {
            path: '/',
            component: () => import('@/module_social/views/SocialHome'),
            name: "SocialFeed",
            meta: {
              title: APP_NAME + "SocialFeed",
            },
          },
          {
            path: 'user/:userId',
            component: () => import('@/module_social/views/SocialUser'),
            name: "SocialUser",
            meta: {
              title: APP_NAME + "SocialUser",
            },
          },
          {
            path: 'hashtag/:hashtag',
            component: () => import('@/module_social/views/SocialHashtag'),
            name: "SocialHashtag",
            meta: {
              title: APP_NAME + "SocialHashtag",
            },
          },
        ]
      },
      {
        path: '/categories/:categoryid',
        component: () => import('@/module_user/views/Category.vue'),
        name: "Categories",
      },
      {
        path: '/videos/filters',
        component: () => import('@/module_user/views/FilterSearchResults.vue'),
        name: "Categories",
        props: route => ({ search: route.query.search, category: route.query.category, duration: route.query.duration, intensity:route.query.intensity }),
      },
      {
        path: '/tnx/:status/:id',
        component: () => import('../module_user/views/TransactionDetails.vue'),
        name: "TransactionDetails",
        meta: {
          title: APP_NAME + "Transaction Details",
        },
      }
    ]
  },
  // Common route for trainer-profile and tenant page
  {
    path: '/:tenantName',
    component: function() {
      if (isAnonymous())
        return import('@/module_homepage/views/Layout/Layout.vue');
      else return import('@/module_b2b_users/views/layout/B2bLayout.vue');
    },
    children: [
      {
        path: '',
        component: () => import('@/module_user/views/TenantProfile'),
        name: 'Trainer Profile',
      }
    ]
  },
];

export default routes;

function isMobile() {
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  return isAndroid || isiOS;
}

function isPhysio(){
  return (JSON.parse(localStorage.getItem("userInfo")))?.corporate?.theme === "physiotherapy";
}

export async function checkUserLogin(to, from, next) {

  const localuserInfo = JSON.parse(localStorage.getItem("userInfo"));
  const isUserInfoNotAvailable = (!localuserInfo || (localuserInfo && localuserInfo.length === 0) || Object.entries(localuserInfo).length === 0);

  if (isUserInfoNotAvailable) {
    let localuserInfo = defaultUser[0];
    await store.dispatch('saveAnonymousUser', localuserInfo);
    // Avoids redirection to /home page when access /tenant route in incognito.
    if (!['Trainer Profile'].includes(to.name)) {
      return next({path: '/home'});
    }
  }

  else {

    /**
     * This array includes pages which user can't visit when he is logged in eg. sign-in & sign-up page
     * */
    const nonLoggedInPages = ['SignIn', 'SignUp'];

    /**
     * This array includes pages which user can only visit once he is logged in
     * */
    const loggedInPages = ['User Progress', 'Main', 'Edit User Profile', 'EliteFitSocial', 'VerifyUser'];

    /**
     * This array includes pages which only corp user can visit
     * */
    const corpLoginPages = ['ShowB2BChallenge', 'b2b-challenges', 'leaderboard', 'CorporateDashboard'];

    /**
     * This array includes social pages which only activated if corp has specific access
     * */
    const socialPages = ['EliteFitSocial', 'SocialFeed', 'SocialUser', 'SocialHashtag'];

    /**
     * This array redirects to anonymous user pages
     */
    const anonymousPages = ['Discover', 'EndWorkout'];

    // const mobilePages = ['EndWorkout'];
    const mobilePages = [];
    if (isMobile()) {
      if (mobilePages.includes(to.name)) {
        next({ name : to.name + " Mobile" });
        return;
      }
    }

    if (!isAnonymous()) {
      if (nonLoggedInPages.includes(to.name)) {
        next("/");
        return;
      }

      const currentUser = store.state.userInfo;
      const corporate = currentUser?.corporate;
      if (corporate) {
        // check if profile completed when corporate has completeProfileMandatory true
        const completeProfileMandatory = corporate.config?.completeProfileMandatory === true;
        const isProfileCompleted = currentUser.profile_completed === true;
        if (completeProfileMandatory && !isProfileCompleted && currentUser.role == "Enduser")
          return next({ name: 'Complete Profile' });
      }
      if (corpLoginPages.includes(to.name) && !store.state.userInfo.corporate) {
        next("/");
        return;
      }
      if (socialPages.includes(to.name) && !hasSocialAccess()) {
        next("/");
        return;
      }
    }
    else {
      if (anonymousPages.includes(to.name)) {
        next(to.path.replace("/user", ""));
        return;
      }
      if (loggedInPages.includes(to.name) || corpLoginPages.includes(to.name)) {
        next("/");
        return;
      }
    }
  }
  next();
}

function hasSocialAccess() {
  return store.state?.userInfo?.corporate?.show_social;
}

function isAnonymous() {
  if (store.state.userInfo) {
    return store.state?.userInfo?.isAnonymousUser;
  } else {
    return true;
  }
}

function getRedirectTo() {
  if (!isAnonymous()) {
    return store.state.defaultLandingPage;
  }
  return '/home';
}